import {
  createMultiStyleConfigHelpers,
  mergeMultiStyleConfig,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const CustomStatusModalParts = [
  'footerContainer',
  'bodyContainer',
  'inputContainer',
  'inputLabel',
] as const

const helpers = createMultiStyleConfigHelpers(CustomStatusModalParts)
export const CustomStatusModalStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    bodyContainer: {
      flexDirection: 'column',
      paddingY: '0.25rem',
      paddingX: '1rem',
      gap: '1.5rem',
    },
    inputContainer: {
      flexDirection: 'column',
      gap: '0.25rem',
    },
    inputLabel: {
      ...textStyles[textStyleKeys.Body4_Bold],
    },
    footerContainer: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '0.62rem',
    },
  },
})

export const useCustomStatusModalStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(CustomStatusModalStyle, props) as MultiStyleType<
    typeof CustomStatusModalParts
  >
}
